var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.videoShow,
            expression: "!videoShow",
          },
        ],
        staticClass: "video-mask",
        on: { click: _vm.playVideo },
      },
      [
        _c("img", {
          attrs: { src: _vm.coverImg, alt: "" },
          on: {
            load: function ($event) {
              return _vm.imgFinished()
            },
          },
        }),
        _vm._v(" "),
        _vm._m(0),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.complete && _vm.videoShow,
            expression: "!complete && videoShow",
          },
        ],
        staticClass: "sa-v-box",
        attrs: { id: "video-poster" },
        on: { click: _vm.playVideo },
      },
      [
        _c("video", {
          staticStyle: { "object-fit": "fill" },
          attrs: {
            id: "sa-box",
            poster: _vm.coverImg,
            src: _vm.url,
            controls: "controls",
            autoplay: "autoplay",
            preload: "",
            width: "100%",
            "x-webkit-airplay": "allow",
            "webkit-playsinline": "true",
            playsinline: "true",
            "x5-playsinline": "true",
            "x5-video-player-fullscreen": "false",
          },
          on: { ended: _vm.playEnd },
        }),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "video-play" }, [
      _c("i", { staticClass: "icon-play" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }